import React from "react";
import { withStyles } from "@material-ui/core/styles";

export const GlobalCss = withStyles({
  // @global is handled by jss-plugin-global.
  "@global": {
    // App bar control: Start
    ".MuiAppBar-root": {
      "& .MuiBox-root": {
        "&.button-typography-wrapper-left": {
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          "& .MuiTypography-root": {
            fontSize: 14,
            fontWeight: 600,
            fontStretch: "normal",
            fontStyle: "normal",
            lineHeight: "1.29",
            letterSpacing: "normal",
            color: "#ffffff",
            paddingLeft: "15px"
          }
        },
        "&.button-wrapper-right": {
          "& button": {
            marginRight: "10px",
            "&:last-child": {
              marginRight: 0
            }
          }
        }
      }
    },
    // App bar control: End
    // Button control: Start
    ".MuiButton-text": {
      "& .MuiButton-label": {
        "& .MuiButton-iconSizeSmall": {
          "& svg": {
            fontSize: "12px"
          },
          "& img": {
            height: "16px",
            width: "16px"
          }
        }
      }
    },
    ".MuiButton-startIcon": {
      "&.MuiButton-iconSizeSmall": {
        "& img": {
          height: "16px",
          width: "16px"
        }
      },
      "&.MuiButton-iconSizeMedium": {
        "& img": {
          height: "16px",
          width: "16px"
        }
      }
    },
    // Button control: End
    ".MuiChip-root": {
      // backgroundColor: "#11ceef",
      color: "#000"
      // borderRadius: "6px",
    },
    ".MuiSvgIcon-root": {
      "&.MuiChip-deleteIcon": {
        color: "#FFF"
      }
    },
    // table header
    ".rdg-header-row": {
      fontSize: 12,
      fontFamily: `Open Sans, sans-serif !important`
    }
  }
})(() => null);
